import React from 'react';
import { Link } from 'react-router-dom';
import heroVideo from '../assets/videos/hero.mov';
import { projects } from '../data/projects';
import './Home.css';

const Home = () => {
    return (
        <div className="home-page">
            {/* Hero Section */}
            <section className="hero-section">
                <video className="hero-video" autoPlay loop muted playsInline>
                    <source src={heroVideo} type="video/quicktime" />
                    <source src={heroVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </section>

            {/* Biography Section */}
            <section className="bio-section">
                <div className="bio-container">
                    <h3>ABOUT ME</h3>
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris
                        nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
                        reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
                    </p>
                </div>
            </section>

            {/* Projects Section */}
            <section className="projects-section">
                <h3>PROJECTS</h3>
                <div className="projects-grid">
                    {projects.map((project) => (
                        <Link to={`/project/${project.id}`} key={project.id} className="project-card">
                            <div className="project-thumbnail">
                                <img src={project.coverImage} alt={project.title} />
                                <div className="project-overlay">
                                    <span>{project.title}</span>
                                </div>
                            </div>
                            <div className="project-info">
                                <h4>{project.title}</h4>
                                <p>{project.category}</p>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            {/* Contact Section */}
            <section className="contact-section">
                <div className="contact-cta">
                    <h3>Interested in working together?</h3>
                    <Link to="/contact" className="cta-button">
                        Get in Touch
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Home;
